
export default {
  name: 'EstimatedDate',
  inheritAttrs: false,
  props: {
    orderActivityId: {
      type: Number,
      default: 0,
    },
    activitiesGroup: {
      type: [Array, Object],
      default: null,
    },
  },
  data: () => ({
    sparePartNoStock: [],
  }),
  mounted() {
    this.getItems();
  },
  methods: {
    getItems() {
      if (this.activitiesGroup) {
        this.activitiesGroup.forEach((item) => {
          if (item.order_activity_id === this.orderActivityId && item.estimated_date && item.pack_category !== 'CP') {
            this.sparePartNoStock.push(item);
          }
        });
      }
    },
    dateFormat(date) {
      const dateF = date.split('T');
      return dateF[0];
    },
  },
};
